;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/expired-activation\"},{\"path\":\"/forgot-password\"},{\"path\":\"/login\"},{\"path\":\"/oauth/consent\"},{\"path\":\"/reset-password\"},{\"path\":\"/set-password\"},{\"path\":\"/terms-acceptance\"},{\"path\":\"/two-factor-auth\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.3";globalThis["_sentryRewritesTunnelPath"] = "/sentry-tunnel";import { persistCampaignAttributionFromUrl } from '@workspace/analytics/campaign-attribution';
import { sentryOnRouterTransitionStart } from '@workspace/analytics/sentry/instrumentation-client';
import { initializePrivacyFirstPostHog } from '@workspace/analytics/posthog/client';
import { initializeSentry } from '@workspace/analytics/sentry/client';
import { installBrowserTranslationGuard } from '@workspace/ui/lib/browser-translation-guard';

installBrowserTranslationGuard();

persistCampaignAttributionFromUrl();

initializePrivacyFirstPostHog({
  app: 'auth-app',
  key: process.env.NEXT_PUBLIC_POSTHOG_KEY,
});

initializeSentry({ app: 'auth-app' });

export const onRouterTransitionStart = sentryOnRouterTransitionStart;
